import React ,{useEffect, useState} from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { Link } from 'react-router-dom';

import { useMediaQuery } from 'react-responsive'
import '../../styles/index.css';
import boxMainImmage from '../../images/new_images/front-direct-image-1.png';
import boxMainImmageMobile from '../../images/new_images/front-direct-image-1-mobile.jpg';
import boxSidePotraite from '../../images/side-potrait.png';
import boxFront from '../../images/front-strieght.png';
import boxFrontSided from '../../images/front-sided.png';
// import boxBack from '../../images/back-striaght.png';
// import boxBackSided from '../../images/back-sided.png';
import boxBackSided from '../../images/new_images/back-side.png';
import boxLoadSupport from '../../images/new_images/load_support.png';
import boxBackSidedNew from '../../images/new_images/back_sided-new.png';
import boxSided from '../../images/new_images/sided_new.png';
import boxFrontFacingPowerBtn from '../../images/new_images/front_sided_power_btn_focus.png';
import Icons from '../icons';
import ReactGA from 'react-ga';






export function Header(){
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-device-width: 800px)'
      })

    return(
        <div style={{
            height:'50px',position:'fixed',left:'0px',right:'0px',display:'flex',flexDirection:'row',justifyContent:'space-between',
            alignItems:'center',zIndex:1000,overflow:'hidden'
            }}>

            <div style={{paddingLeft:'15px',color:'green'}}>
                {(isDesktopOrLaptop)?
                <Icons icon="logo" size="200" color="#429a37"/>:
                <Icons icon="logo" size="140" color="#429a37"/>}
            </div>
            
            <div style={{}}></div>
        </div>
    )
} 


export function TopStage(){

    const [showTopBuy, setShowTopBuy] = useState(false);

    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-device-width: 800px)'
      })

      function openTopBuy(){
        setShowTopBuy(true);
      }

      const openWhatsapp = (data) => {
        console.log(data);
        window.open("https://wa.me/+2349070811425?text=Hi", "_blank");
        ReactGA.pageview("whatsapp clicked");
      }


    return(
    <div style={{backgroundColor:'#000000',width:'100%',display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'center'}}>

     {(isDesktopOrLaptop)?
     <div style={{position:'relative'}}>



        <div style={{backgroundColor:'',padding:'0px',position:'absolute',left:0,top:60,right:0,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

            <div className="H1_pc">Enjoy 24 Hours Power. Get Powerbox.</div>
            
            <div className="H2_pc">1 Year Warranty. 10years Guranteed.</div>

            <div style={{paddingBottom:'15px'}} className="H3_pc">For Homes | Offices | Small Businesses</div>


            {/* <div onClick={openWhatsapp} style={{backgroundColor:'#FFFFFF',padding:'15px',borderRadius:'5px',marginTop:15,padding:'5px 15px 5px'}}>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',color:'#000000',fontSize:'13px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>
                    <div style={{color:'#000000',opacity:0.6}}>Click here to chat with us on whatsapp</div>
                    <div style={{fontSize:'29px',fontWeight:500}}>09070811425</div>
                </div>
            </div> */}

            <AgentModal />

            
        </div>

        
        <div style={{padding:'0px 0px 0px',width:'100%',display:'flex',justifyContent:'center',alignItems:'flex-end',backgroundColor:'red'}} className="">
            <img src={boxMainImmage} style={{width:'100%'}}/>
        </div>

     </div>
     :


     <div style={{position:'relative',backgroundColor:'',marginTop:0}}>
           
            <div style={{backgroundColor:'',padding:'0px',position:'absolute',left:0,right:0,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',zIndex:'100'}}>

                <div className="H1" style={{fontSize:'29px',textAlign:'center'}}>Enjoy 24 Hours Power. Get Powerbox.</div>

                <div className="H2" style={{fontSize:'18px',textAlign:'center',marginBottom:4,marginTop:10}}>1 Year Warranty. 10years Guranteed.</div>

                <div className="H3" style={{fontSize:'13px',textAlign:'center',paddingBottom:20}}>For Homes | Offices | Small Businesses</div>


                {/* <div onClick={openWhatsapp} style={{backgroundColor:'#FFFFFF',padding:'15px',borderRadius:'5px',marginTop:20,padding:'5px 15px 5px'}}>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',color:'#000000',fontSize:'13px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>
                        <div style={{color:'#000000',fontSize:11,opacity:0.6}}>Click here to chat with us on whatsapp</div>
                        <div style={{fontSize:'24px',fontWeight:500}}>09070811425</div>
                    </div>
                </div> */}
                <AgentModal />


            </div>



    
        <div style={{}} className="">
             <img src={boxMainImmageMobile} style={{width:'100%',marginBottom:-4}}/>
        </div>


    </div>
     }

    </div>)
}


export function SecondStagePc(){

    return(
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',paddingTop:'60px',paddingBottom:'60px'}}>
            
            <div style={{width:'1150px',display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                <div style={{flex:1}}>
                    
                    
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div className="sub2PcCircles design_icon" style={{borderRadius:'100px'}}>
                           {/* <Icons icon="design" size="35" color="#FFFFFF"/> */}
                           <img src={require('../../images/new_images/designer_icon.png')} style={{width:40,height:40}}/>
                        </div>
                        
                        <div style={{flex:1}}>
                            <div style={{}} className="sub2PcH1">Clean Design</div>
                            <div style={{}} className="sub2PcH2">The powerbox is aesthetically built to look great in-home.</div>
                        </div>

                    </div>



                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div className="sub2PcCircles design_icon2" style={{justifyContent:'center',alignItems:'center',display:'flex',borderRadius:'100px'}}>
                            <img src={require('../../images/new_images/arm.png')} style={{width:45,height:45}}/>
                        </div>
                        
                        <div style={{flex:1}}>
                            <div style={{}} className="sub2PcH1">Rigid and Durable</div>
                            <div style={{}} className="sub2PcH2">Manufactured from high grade steel, the Powerbox will withstand extreme environments without damage.</div>
                        </div>
                        

                    </div>




                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div className="sub2PcCircles design_icon3" style={{justifyContent:'center',alignItems:'center',display:'flex',borderRadius:'100px'}}>
                            <img src={require('../../images/new_images/speed.png')} style={{width:45,height:45}}/>
                        </div>
                        
                        <div style={{flex:1}}>
                            <div style={{}} className="sub2PcH1">Recharge Speed</div>
                            <div style={{}} className="sub2PcH2">Powerbox offers you the fastest recharge. You do not need to worry anymore about days with low sunlight.</div>
                        </div>

                         

                    </div>


                    


                    

                </div>

                <div style={{flex:0.9,justifyContent:'center',alignItems:'center',display:'flex'}}>
                    <img src={require('../../images/new_images/sided_pc.png')} style={{maxWidth:'250px',marginBottom:-2}}/>
                </div>

                <div style={{flex:1,background:'white'}}>

                    
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-end',}}>
                            <div style={{}} className="sub2PcH1"> The Bundle</div>
                            <div style={{textAlign:'right'}} className="sub2PcH2">The powerbox bundle comes with two high powered solar panels and the unit.</div>
                        </div>

                        <div className="sub2PcCircles2" style={{
                            justifyContent:'center',alignItems:'center',display:'flex',
                            backgroundColor:'#FF3F2C',borderRadius:'100px'}}>
                                <img src={require('../../images/new_images/solar-energy.png')} style={{width:45,height:45}}/>
                        </div>
                    </div>



                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-end',}}>
                            <div style={{}} className="sub2PcH1">Power Availabity</div>
                            <div style={{textAlign:'right'}} className="sub2PcH2">Powerbox provides all-day power and over 10hrs power supply at night!</div>
                        </div>

                        <div className="sub2PcCircles2" style={{
                            justifyContent:'center',alignItems:'center',display:'flex',
                            backgroundColor:'#0071E2',borderRadius:'100px'}}>
                                <img src={require('../../images/new_images/energetic.png')} style={{width:45,height:45}}/>
                            </div>
                    </div>



                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-end',}}>
                            <div style={{}} className="sub2PcH1">Portability</div>
                            <div style={{textAlign:'right'}} className="sub2PcH2">Get power everywhere, anywhere. It’s not just for your home but for your medium-powered appliances. It’s the perfect package.</div>
                        </div>

                        <div className="sub2PcCircles2" style={{
                            justifyContent:'center',alignItems:'center',display:'flex',
                            backgroundColor:'#E5AAFA',borderRadius:'100px'}}>
                                <img src={require('../../images/new_images/pinch.png')} style={{width:45,height:45}}/>
                        </div>
                    </div>





                    {/* <div style={{}}>4</div>
                    <div style={{}}>5</div>
                    <div style={{}}>6</div> */}
                </div>

            </div>

        </div>
    )
}






export function SecondStageMobile(){

    return(
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',padding:'10px 5px 0px'}}>
            
            <div style={{width:'100%',display:'flex',flexDirection:'column'}}>
                <div style={{flex:1}}>
                    
                    
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div className="sub2PcCircles design_icon" style={{borderRadius:'100px',}}>
                           <img src={require('../../images/new_images/designer_icon.png')} style={{width:40,height:40}}/>
                        </div>
                        
                        <div style={{flex:1}}>
                            <div style={{}} className="sub2PcH1">Clean Design</div>
                            <div style={{}} className="sub2PcH2">The powerbox is aesthetically built to look great in-home.</div>
                        </div>

                    </div>



                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div className="sub2PcCircles design_icon2" style={{justifyContent:'center',alignItems:'center',display:'flex',backgroundColor:'#FAA44',borderRadius:'100px'}}>
                                <img src={require('../../images/new_images/arm.png')} style={{width:45,height:45}}/>
                            </div>
                        
                        <div style={{flex:1}}>
                            <div style={{}} className="sub2PcH1">Rigid and Durable</div>
                            <div style={{}} className="sub2PcH2">Manufactured from high grade steel, the Powerbox will withstand extreme environments without damage.</div>
                        </div>
                        

                    </div>




                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div className="sub2PcCircles design_icon3" style={{justifyContent:'center',alignItems:'center',display:'flex',borderRadius:'100px'}}>
                            <img src={require('../../images/new_images/speed.png')} style={{width:45,height:45}}/>
                        </div>
                        
                        <div style={{flex:1}}>
                            <div style={{}} className="sub2PcH1">Recharge Speed</div>
                            <div style={{}} className="sub2PcH2">Powerbox offers you the fastest recharge. You do not need to worry anymore about days with low sunlight.</div>
                        </div>

                    </div>


                </div>


                <div style={{flex:1}}>

                    
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'0px 0px 50px'}}>
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-end',}}>
                            <div style={{}} className="sub2PcH1">The Bundle</div>
                            <div style={{textAlign:'right'}} className="sub2PcH2">The powerbox bundle comes with two high powered solar panels and the unit.</div>
                        </div>

                        <div className="sub2PcCircles2" style={{
                            justifyContent:'center',alignItems:'center',display:'flex',
                            backgroundColor:'#FF3F2C',borderRadius:'100px'}}>
                                <img src={require('../../images/new_images/solar-energy.png')} style={{width:45,height:45}}/>

                            </div>
                    </div>



                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-end',}}>
                            <div style={{}} className="sub2PcH1">Power Availabity</div>
                            <div style={{textAlign:'right'}} className="sub2PcH2">Powerbox provides all-day power and over 10hrs power supply at night!</div>
                        </div>

                        <div className="sub2PcCircles2" style={{
                            justifyContent:'center',alignItems:'center',display:'flex',
                            backgroundColor:'#0071E2',borderRadius:'100px'}}>
                                {/* <Icons icon="electric" size="35" color="#FFFFFF"/> */}
                                <img src={require('../../images/new_images/energetic.png')} style={{width:45,height:45}}/>

                            </div>
                    </div>



                    <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'flex-start',margin:'30px 0px 50px'}}>
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-end',}}>
                            <div style={{}} className="sub2PcH1">Portability</div>
                            <div style={{textAlign:'right'}} className="sub2PcH2">Get power everywhere, anywhere. It’s not just for your home but for your medium-powered appliances. It’s the perfect package.</div>
                        </div>

                        <div className="sub2PcCircles2" style={{
                            justifyContent:'center',alignItems:'center',display:'flex',
                            backgroundColor:'#E5AAFA',borderRadius:'100px'}}>
                                <img src={require('../../images/new_images/pinch.png')} style={{width:45,height:45}}/>

                            </div>
                    </div>

                </div>

            </div>

        </div>
    )
}



export function AnotherStagePC(){
    return(
        <div style={{backgroundColor:'#000000'}}>
            <div style={{position:'relative',maxWidth:'1600px',margin:'auto' }} className="anotherStageBg">
                <div style={{}}>
                    {/* <img src={require('../../images/new_images/bg1.jpg')} style={{width:'100%'}}/> */}
                </div> 
                
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                    
                    <div style={{flex:0.65}}>
                        <img src={require('../../images/new_images/pbchangeover.jpg')} style={{width:'100%'}}/>
                    </div>

                    <div style={{color:"#FFFFFF",flex:0.45,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <div style={{textAlign:'center',color:'#FFFFFF',fontSize:'32px',fontFamily:"'Roboto', sans-serif",fontWeight:200,marginBottom:0,padding:5}}>Experience the future with Powerbox</div>
                        <div style={{textAlign:'left',lineHeight:'25px',color:'#FFFFFF',fontSize:'18px',fontFamily:"'Roboto', sans-serif",fontWeight:300,padding:25}}>The sleek upgrade to your generator. It's the unstoppable force that runs tirelessly day and night,ensuring power cuts are a thing of the past. Upgrade now and embrace uninterrupted power like never before.</div>
                    </div>

                </div>

            </div>
        </div>
    )
}







export function AnotherStageMobile(){
    return(
        <div style={{position:'relative',maxWidth:'1600px' }} className="anotherStageBg">
           
            <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',alignItems:'center'}}>
                
                <div style={{flex:0.65}}>
                    <img src={require('../../images/new_images/pbchangeover.jpg')} style={{width:'100%'}}/>
                </div>

                <div style={{color:"#FFFFFF",flex:0.45,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                    <div style={{textAlign:'center',color:'#FFFFFF',fontSize:'32px',fontFamily:"'Roboto', sans-serif",fontWeight:200,marginBottom:0,padding:5,paddingTop:20,opacity:0.85}}>Experience the future with Powerbox</div>
                    <div style={{textAlign:'left',lineHeight:'25px',color:'#FFFFFF',fontSize:'18px',fontFamily:"'Roboto', sans-serif",fontWeight:300,padding:10,paddingBottom:50,opacity:0.85}}>The sleek upgrade to your generator. It's the unstoppable force that runs tirelessly day and night,ensuring power cuts are a thing of the past. Upgrade now and embrace uninterrupted power like never before.</div>
                </div>

            </div>

        </div>
    )
}





// export function ThirdStagePc(){
//     return(
//         <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'row'}}>

//             <div style={{padding:'10px',display:'flex',flexDirection:'row',backgroundColor:'#FFFFFF',maxWidth:'1600px',flex:1}}>




//                     <div style={{padding:'10px',display:'flex',flexDirection:'column',backgroundColor:'#FFFFFF',maxWidth:'1600px',flex:1}}>

                                    
                                        
//                         <div style={{border:'1px solid #F1F1F1',backgroundColor:'#F4F4F4',marginBottom:'0px',display:'flex',flexDirection:'column',borderRadius:'1px',borderRadius:5,overflow:'hidden'}}>


//                             <div style={{}}>
//                                 <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingRight:'15px',padding:'10px 0px 0px 20px'}}>
                                   
//                                     <div style={{fontSize:'35px',fontFamily:"'Roboto', sans-serif",fontWeight:300,padding:'5px 0px 0px'}}>
//                                         Robust Design
//                                     </div>
//                                     <div style={{fontSize:'25px',fontFamily:"'Roboto', sans-serif",fontWeight:300,}}>
//                                         Carefully built out of simplicity.
//                                     </div>

//                                 </div>
//                             </div>



//                             <div style={{display:'flex',justifyContent:'center',alignItems:'center',flex:1,overflow:'hidden',marginTop:0}}>
//                                 <img src={boxFrontFacingPowerBtn} style={{width:'100%'}}/>
//                             </div>



//                         </div>



//                     </div>





//                 <div 
//                     style={{
//                         border:'1px solid #FCFCFC',backgroundColor:'#FAFAFA',width:'300px',height:'650px',
//                         flex:1,marginLeft:'5px',display:'flex',flexDirection:'column',marginTop:8,borderRadius:5}}>

//                     <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
//                         <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
//                             <div style={{fontSize:'40px',fontFamily:"'Roboto', sans-serif",fontWeight:300,padding:'15px 0px 0px'}}>Easy to install</div>
//                             <div style={{fontSize:'25px',fontFamily:"'Roboto', sans-serif",fontWeight:300,}}>Without special technical assistance</div> 
//                         </div>
//                     </div>

//                     <div style={{flex:1,display:'flex',justifyContent:'center',alignItems:'flex-end',flexDirection:'column'}}>
//                         <div style={{marginBottom:'0px',flex:1,display:'flex',justifyContent:'center',alignItems:'center'}}>
//                             <img src={boxBackSidedNew} style={{width:'100%'}}/>
//                         </div>
//                     </div>

//                 </div>



//             </div>
//         </div>
//     )

// }










// export function ThirdStageMobile(){
//     return(
//         <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'row'}}>

            
            
            
//             <div style={{padding:'10px',display:'flex',flexDirection:'column',backgroundColor:'#FFFFFF',maxWidth:'1600px',flex:1}}>

                
                
//                 <div style={{border:'1px solid #F1F1F1',backgroundColor:'#F4F4F4',marginBottom:'5px',display:'flex',flexDirection:'column',borderRadius:'1px'}}>

                
//                 <div>
//                     <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'flex-start',paddingRight:'15px',padding:'10px 0px 0px 20px'}}>
//                         <div style={{fontSize:'31px',fontFamily:"'Roboto', sans-serif",fontWeight:300,padding:'5px 0px 0px'}}>
//                             Robust Design
//                         </div>
//                         <div style={{fontSize:'13px',fontFamily:"'Roboto', sans-serif",fontWeight:500,padding:'5px 0px 10px 30px',opacity:0.7}}>
//                             Carefully built out of simplicity.
//                         </div>
//                     </div>
//                 </div>



//                 <div style={{display:'flex',justifyContent:'center',alignItems:'center',flex:1,overflow:'hidden'}}>
//                     <img src={boxFrontFacingPowerBtn} style={{width:'120%'}}/>
//                 </div>

                
//                 <div style={{display:'flex',flexDirection:'row',backgroundColor:'#f4f4f4'}}>
                    
//                     <div style={{display:'flex',justifyContent:'center',alignItems:'center',flex:1,margin:'5px 2.5px 5px 5px',backgroundColor:'#FFFFFF',borderRadius:2}}>
//                         <div style={{display:'flex',justifyContent:'center',alignItems:'center',overflow:'hidden'}}>
//                             <img src={boxSided} style={{width:'100%',}}/>
//                         </div>
//                     </div>


//                     <div style={{display:'flex',justifyContent:'center',alignItems:'center',flex:1,margin:'5px 5px 5px 2.5px',backgroundColor:'#FFFFFF',borderRadius:2}}>
//                         <div style={{display:'flex',justifyContent:'center',alignItems:'center',}}>
//                             <img src={boxBackSidedNew} style={{width:'100%',}}/>
//                         </div>
//                     </div>
                        
//                 </div>

//                 </div>
 


//             </div>
//         </div>
//     )

// }




export function NewStageMobile(){
    return(
        <div className="power_rating-carrier-m" style={{}}>
            
            

            <div style={{padding:5,paddingBottom:10,marginTop:0}}>
                <img src={require("../../images/new_images/load_support_img.png")} style={{width:'100%',}}/>
            </div>

            <div  style={{fontFamily:"'Roboto', sans-serif",fontWeight:200,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',padding:5}}>
               <div style={{textAlign:'center',fontSize:25,paddingBottom:15,paddingTop:15}}>
                    A single Powerbox Pro can power appliances and equipment for homes and businesses. 
               </div>
               <div style={{padding:'0px 10px 50px',fontSize:16,textAlign:'left',lineHeight:'22px'}}>
                    Its remarkable how this elegantly designed device can handle all these loads continously, day and night. Many users describe it as an incredible power generation machine.
               </div>
            </div>

            {/* <div style={{fontSize:10,color:'#FFFFFF',padding:'10px 5px 5px 10px'}}>With a single powerbox you can power all this load at once</div> */}

        </div>
    )
}



export function NewStagePc(){
    return(
        <div style={{overflow:'hidden'}}>
            <div className="power_rating-carrier-pc" style={{marginTop:-10}}>
                <div style={{padding:'0px',maxWidth:'1600px',flex:1,margin:'0px auto 0px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>

                    <div style={{flex:0.55,fontFamily:"'Roboto', sans-serif",fontWeight:200,padding:'0px',display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                        <div style={{maxWidth:700,padding:'0px 10px 0px'}}>
                        
                            <div style={{textAlign:'center',fontSize:45,paddingBottom:15,paddingTop:15}}>
                                A single Powerbox Pro can power appliances and equipment for homes and businesses. 
                            </div>
                            <div style={{padding:'10px 30px 50px',fontSize:22,textAlign:'center',lineHeight:'29px'}}>
                                    Its remarkable how this elegantly designed device can handle all these loads continously, day and night. Many users describe it as an incredible power generation machine.
                            </div>
                        
                        </div>
                    </div>

                    <div style={{flex:0.45,padding:5,paddingBottom:50,display:'flex',justifyContent:'center',alignItems:'center',marginTop:0,padding:30}}>
                        <img src={require("../../images/new_images/load_support_img.png")} style={{width:'90%',}}/>
                    </div>
                    
                </div>
                
            </div>
        </div>
    )
}



export function AwardViewPc(){
    return(
        <div style={{ }} className="award-wrapper">
            <div style={{color:'#E7C469',width:'100%',fontFamily:"'Roboto', sans-serif",fontWeight:200,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                
                <div style={{maxWidth:400,margin:'auto',paddingTop:60}}>
                    <img src={require("../../images/new_images/award_img.png")} style={{width:'100%' }}/>
                </div>
                <div style={{fontSize:30}}>Awarded</div>
                <div style={{paddingTop:50,fontSize:60,textAlign:'center'}}>The Most Innovative Clean-energy Company</div>
                <div style={{paddingTop:10,fontSize:25,paddingBottom:70,textAlign:'center'}}>By Lion's Head Global Partners ( UK )</div>
            
            </div>

           
        </div>
    )
}



export function AwardViewMobile(){
    return(
        <div style={{ }} className="award-wrapper">
            <div style={{color:'#E7C469',width:'100%',fontFamily:"'Roboto', sans-serif",fontWeight:200,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                
                <div style={{width:'100%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',margin:'auto',paddingTop:40}}>
                    <img src={require("../../images/new_images/award_img.png")} style={{width:'50%' }}/>
                </div>
                <div style={{fontSize:20}}>Awarded</div>
                <div style={{paddingTop:50,fontSize:30,textAlign:'center',fontWeight:100}}>The Most Innovative Clean-energy Company</div>
                <div style={{paddingTop:10,fontSize:15,paddingBottom:70,textAlign:'center'}}>By Lion's Head Global Partners ( UK )</div>
            
            </div>

           
        </div>
    )
}




export function TestimonyFuncMobile(){
    return(
        <div className="testimony_wrapper_m" style={{}}>

            <div>
                <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-start',padding:'30px 10px 30px'}}>
                    <div style={{fontSize:'27px',fontFamily:"'Roboto', sans-serif",fontWeight:300,padding:'5px 0px 0px'}}>
                        What Our Customers Say
                    </div>
                </div>
            </div>


            
            {/* bubble starts */}
            <div style={{}} className='testimony_wrapper'>
                <div className='bubble_profile_carrier'>
                    <div className='bubble_profile_wrapper'>
                        <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <img src={require('../../images/new_images/chat.png')} style={{width:25,height:25}}/>
                        </div>
                    </div>
                    <div className='bubble_profile_name'>Halidu - Baruten, Kwara State</div>
                </div>

                <div style={{}} className='bubble_mgs_wrapper'>
                I love the ease of use of the Powerbox, my family use it daily to power the whole house. Thanks to Powerbox my children can
study at night without any challenge. Thankfully, I can also plug-in appliances into any wall socket in the house which is very convienent.
                </div>
            </div>
            {/* bubble ends */}


            {/* bubble starts */}
            <div style={{}} className='testimony_wrapper'>
                <div className='bubble_profile_carrier'>
                    <div className='bubble_profile_wrapper'>
                        <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <img src={require('../../images/new_images/chat.png')} style={{width:25,height:25}}/>
                        </div>
                    </div>
                    <div className='bubble_profile_name'>Jamil - Kano, Kano State</div>
                </div>

                <div style={{}} className='bubble_mgs_wrapper'>
                I do not worry about coming back home from work and not having PHCN power, I just turn on my powerbox all through the Night.
I had to introduce Powerbox to a co-worker who is currently also a customer.
                </div>
            </div>
            {/* bubble ends */}


            {/* bubble starts */}
            <div style={{}} className='testimony_wrapper'>
                <div className='bubble_profile_carrier'>
                    <div className='bubble_profile_wrapper'>
                        <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <img src={require('../../images/new_images/chat.png')} style={{width:25,height:25}}/>
                        </div>
                    </div>
                    <div className='bubble_profile_name'>Oyindamola - Ogere, Ogun State</div>
                </div>

                <div style={{}} className='bubble_mgs_wrapper'>
                I am a software programer that relies on the Powerbox for on-demand power for my workstation to meet my work deadlines, anytime anyday.
Great product.
                </div>
            </div>
            {/* bubble ends */}





        </div>
    )
}








export function TestimonyFuncPc(){
    return(
        <div className="testimony_wrapper_pc" style={{}}>
            <div style={{margin:'0px auto 0px'}}>

                    <div>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-start',padding:'30px 10px 30px'}}>
                            <div style={{fontSize:'27px',fontFamily:"'Roboto', sans-serif",fontWeight:300,padding:'5px 0px 0px'}}>
                                What Our Customers Say
                            </div>
                        </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'row',paddingTop:'20px',paddingBottom:'20px'}}>
                            
                            {/* bubble starts */}
                            <div style={{}} className='testimony_wrapper_bubble_pc'>
                                <div className='bubble_profile_carrier'>
                                    <div className='bubble_profile_wrapper'>
                                        <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                            <img src={require('../../images/new_images/chat.png')} style={{width:25,height:25}}/>
                                        </div>
                                    </div>
                                    <div className='bubble_profile_name'>Halidu - Baruten, Kwara State</div>
                                </div>

                                <div style={{}} className='bubble_mgs_wrapper'>
                                I love the ease of use of the Powerbox, my family use it daily to power the whole house. Thanks to Powerbox my children can
                study at night without any challenge. Thankfully, I can also plug-in appliances into any wall socket in the house which is very convienent.
                                </div>
                            </div>
                            {/* bubble ends */}


                            {/* bubble starts */}
                            <div style={{}} className='testimony_wrapper_bubble_pc'>
                                <div className='bubble_profile_carrier'>
                                    <div className='bubble_profile_wrapper'>
                                        <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                            <img src={require('../../images/new_images/chat.png')} style={{width:25,height:25}}/>
                                        </div>
                                    </div>
                                    <div className='bubble_profile_name'>Jamil - Kano, Kano State</div>
                                </div>

                                <div style={{}} className='bubble_mgs_wrapper'>
                                I do not worry about coming back home from work and not having PHCN power, I just turn on my powerbox all through the Night.
                I had to introduce Powerbox to a co-worker who is currently also a customer.
                                </div>
                            </div>
                            {/* bubble ends */}


                            {/* bubble starts */}
                            <div style={{}} className='testimony_wrapper_bubble_pc'>
                                <div className='bubble_profile_carrier'>
                                    <div className='bubble_profile_wrapper'>
                                        <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                            <img src={require('../../images/new_images/chat.png')} style={{width:25,height:25}}/>
                                        </div>
                                    </div>
                                    <div className='bubble_profile_name'>Oyindamola - Ogere, Ogun State</div>
                                </div>

                                <div style={{}} className='bubble_mgs_wrapper'>
                                I am a software programer that relies on the Powerbox for on-demand power for my workstation to meet my work deadlines, anytime anyday.
                Great product.
                                </div>
                            </div>
                            {/* bubble ends */}

                    </div>




            </div>
        </div>
    )
}






export function FourthStagePc(){

    const [showContact, setShowContact] = useState(false);

    function processPurchase(){
        setShowContact(true);
    }


    return(
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'row'}}>
            <div style={{padding:'10px',display:'flex',flexDirection:'row',backgroundColor:'#FFFFFF',maxWidth:'1600px',flex:1}}>

            <div style={{padding:'10px',display:'flex',flexDirection:'row',backgroundColor:'#F4F4F4',flex:1}}>
                
                <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'30px'}}>
                   
                    <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                        <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                        <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Continous Day Time Use</div>
                    </div>

                    <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                        <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                        <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Install in few minutes</div>
                    </div>

                    <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                        <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                        <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Portable and Movable</div>
                    </div>

                    <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                        <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                        <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Long lasting Energy Storage</div>
                    </div>

                    <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                        <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                        <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>24/7 Customer Service</div>
                    </div>

                </div>





                
                <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                    <div style={{fontSize:'50px',fontFamily:"'Roboto', sans-serif",fontWeight:600}}>Powerbox Pro</div>

                    {(!showContact)?
                    <CSSTransitionGroup
                    transitionName="fadeout"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={true}
                    >
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                            <div style={{fontSize:'17px',fontFamily:"'Roboto', sans-serif",fontWeight:300,paddingBottom:10}}>Comes with Two Solar Panels</div>
                            {/* <div style={{fontSize:'40px',fontFamily:"'Roboto', sans-serif",fontWeight:400,padding:'10px 0px 0px',display:'flex',flexDirection:'row'}}>
                                <div style={{marginBottom:'0px'}}>
                                    <div style={{marginBottom:'10px'}}>
                                        <Icons icon="naira" size="37" color="#000000"/>
                                    </div>
                                </div>
                                <div style={{}}>150,000</div>
                            </div> */}
                            {/* <div onClick={processPurchase} style={{padding:'15px 50px 12px',backgroundColor:'#FFFFFF',borderRadius:'5px',cursor:'pointer',marginTop:20}} className="buynowBtn">Become a Distributor</div> */}

                            <AgentModal />

                        </div>
                    </CSSTransitionGroup>
                    :undefined}


                   {(showContact)?     
                    <CSSTransitionGroup
                        transitionName="fade"
                        transitionAppear={true}
                        transitionAppearTimeout={1300}
                        transitionEnter={false}
                        transitionLeave={false}
                        >
                        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'15px'}}>
                            <div style={{fontSize:'16px',fontFamily:"'Roboto', sans-serif",fontWeight:400,}}>Chat with us on whatsapp </div>
                            <div style={{fontSize:'35px',fontFamily:"'Roboto', sans-serif",fontWeight:400,}}>09070811425</div>
                        </div>
                    </CSSTransitionGroup>
                    :undefined}

                    



                </div>




            </div>
        </div>
            
        </div>
    )}





    export function FourthStageMobile(){

        const [showContact, setShowContact] = useState(false);
    
        function processPurchase(){
            setShowContact(true);
        }
    
    
        return(
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'row'}}>
                <div style={{padding:'10px',display:'flex',flexDirection:'row',backgroundColor:'#FFFFFF',maxWidth:'1600px',flex:1}}>
    
                <div style={{padding:'10px',display:'flex',flexDirection:'column',backgroundColor:'#F4F4F4',flex:1}}>
                    
                    <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'30px'}}>
                       
                        <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                            <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                            <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Continous Day Time Use</div>
                        </div>
    
                        <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                            <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                            <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Install in few minutes</div>
                        </div>
    
                        <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                            <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                            <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Portable and Movable</div>
                        </div>
    
                        <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                            <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                            <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>Long lasting Energy Storage</div>
                        </div>
    
                        <div style={{padding:'0px 0px 22px',display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                            <div style={{paddingRight:'10px'}}><Icons icon="ok" size="25" color="#00972D"/></div>
                            <div style={{fontSize:'15px',fontFamily:"'Roboto', sans-serif",fontWeight:500,}}>24/7 Customer Service</div>
                        </div>
    
                    </div>
    
    
    
    
    
                    
                    <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'20px'}}>
                        <div style={{fontSize:'40px',fontFamily:"'Roboto', sans-serif",fontWeight:600}}>Powerbox Pro</div>
    
                        {(!showContact)?
                        <CSSTransitionGroup
                        transitionName="fadeout"
                        transitionAppear={true}
                        transitionAppearTimeout={500}
                        transitionEnter={false}
                        transitionLeave={true}
                        >
                            <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingBottom:50}}>
                                <div style={{fontSize:'14px',fontFamily:"'Roboto', sans-serif",fontWeight:300,paddingBottom:15}}>Comes with Two Solar Panels</div>
                                {/* <div style={{fontSize:'40px',fontFamily:"'Roboto', sans-serif",fontWeight:400,padding:'10px 0px 0px',display:'flex',flexDirection:'row'}}>
                                    <div style={{marginBottom:'0px'}}>
                                        <div style={{marginBottom:'10px'}}>
                                            <Icons icon="naira" size="37" color="#000000"/>
                                        </div>
                                    </div>
                                    <div style={{}}>150,000</div>
                                </div> */}
                                {/* <div
                                    onClick={processPurchase} 
                                    style={{padding:'15px 50px 12px',backgroundColor:'#FFFFFF',borderRadius:'5px',cursor:'pointer',marginTop:20}} className="buynowBtn">Buy Now</div> */}

                                <AgentModal />

                            </div>
                        </CSSTransitionGroup>
                        :undefined}
    
    
                       {(showContact)?     
                        <CSSTransitionGroup
                            transitionName="fade"
                            transitionAppear={true}
                            transitionAppearTimeout={1300}
                            transitionEnter={false}
                            transitionLeave={false}
                            >
                            <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'15px'}}>
                                <div style={{fontSize:'16px',fontFamily:"'Roboto', sans-serif",fontWeight:400,}}>Chat with us on whatsapp </div>
                                <div style={{fontSize:'35px',fontFamily:"'Roboto', sans-serif",fontWeight:400,}}>09070811425</div>
                            </div>
                        </CSSTransitionGroup>
                        :undefined}
    
                        
    
    
    
                    </div>
    
    
    
    
                </div>
            </div>
                
            </div>
        )}






    export function FifthStageMobile(){
        return(
            <div className="footer_wrapper">

                <div style={{}} className='footer_logo_holder'>
                    <div style={{}} className='footer_logo_carrier'>
                        <Icons icon="logo" size="160" color="#399947"/>
                    </div>
                </div>


                <div style={{padding:'15px 20px 10px'}}>
                    <div style={{}} className='footer_h1'>Our Products</div>
                    <div style={{}} className='footer_h2'>Powerbox Pro</div>
                    {/* <div style={{}} className='footer_h2'>Powerbox SE</div> */}
                </div>


                {/* <div style={{padding:'0px 20px 10px'}}>
                    <div style={{}} className='footer_h1'>Help</div>
                    <div style={{}} className='footer_h2'>FAQs</div>
                    <div style={{}} className='footer_h2'>Contact Us</div>
                </div> */}

                <div style={{padding:'0px 20px 10px'}}>
                    <div style={{}} className='footer_h1'>Twitter</div>
                    <div style={{}} className='footer_h2'>@powerboxEnergy</div>
                </div>

                <div style={{padding:'0px 20px 10px'}}>
                    <div style={{}} className='footer_h1'>Email</div>
                    <div style={{}} className='footer_h2'>Support@powerbox.com.ng</div>
                </div>

                <div style={{padding:'0px 20px 20px'}}>
                    <div style={{}} className='footer_h1'>Legal</div>
                    <Link to="/terms" style={{textDecoration: 'none'}}><div style={{}} className='footer_h2'>Terms and Conditions</div></Link>
                    <Link to="/refund-policy" style={{textDecoration: 'none'}}><div style={{}} className='footer_h2'>Refund Policy</div></Link>
                    <Link to="/privacy-policy" style={{textDecoration: 'none'}}><div style={{}} className='footer_h2'>Privacy Policy</div></Link>
                </div>

                <div style={{padding:'0px 20px 20px'}}>
                    <div style={{}} className='footer_h1'>Business Address</div>
                    <div style={{}} className='footer_h2'>Ad1, Makarfi Street</div>
                    <div style={{}} className='footer_h2'>Constitution, Kaduna</div>
                    <div style={{}} className='footer_h2'>Nigeria</div>
                </div>


                <div className='last_footer_wrapper'>
                    The Powerbox logo and technologies are trademark properties of Powerbox Energy systems LLC and its regional subsidiaries. 
                    <div style={{padding:'0px 20px 0px'}}>
                        &#169; 2024 Powerbox Energy systems LLC. All Rights Reserved.
                    </div> 
                </div>
                


                {/* the footer of the pagess */}
            </div>  
        )  
    }






    export function FifthStagePc(){
        return(
            <div className="footer_wrapper">


                <div style={{maxWidth:'1600px',margin:'30px auto 30px',display:'flex',flexDirection:'row',padding:'20px 15px 50px'}}>




                    <div style={{flex:1.1,alignItems:'center',display:'flex',flexDirection:'column'}}>
                        <div style={{height:'110px',overflow:'hidden',marginTop:'-65px'}} >
                            <Icons icon="logo2" size="160" color="#399947"/>
                        </div>
                    </div>


                    <div style={{padding:'0px 20px 10px',flex:1}}>
                        <div style={{}} className='footer_h1'>Our Products</div>
                        <div style={{}} className='footer_h2'>Powerbox Pro</div>
                        {/* <div style={{}} className='footer_h2'>Powerbox SE</div> */}
                    </div>


                    <div style={{padding:'0px 20px 10px',flex:1}}>
                        <div style={{}} className='footer_h1'>Twitter</div>
                        <div style={{}} className='footer_h2'>@powerboxEnergy</div>
                    </div>

                    <div style={{padding:'0px 20px 10px',flex:1}}>
                        <div style={{}} className='footer_h1'>Email</div>
                        <div style={{}} className='footer_h2'>Support@powerbox.com.ng</div>
                    </div>

                    <div style={{padding:'0px 20px 20px',flex:1}}>
                        <div style={{}} className='footer_h1'>Legal</div>
                        <Link to="/terms" style={{textDecoration: 'none'}}><div style={{}} className='footer_h2'>Terms and Conditions</div></Link>
                        <Link to="/refund-policy" style={{textDecoration: 'none'}}><div style={{}} className='footer_h2'>Refund Policy</div></Link>
                        <Link to="/privacy-policy" style={{textDecoration: 'none'}}><div style={{}} className='footer_h2'>Privacy Policy</div></Link>
                    </div>

                    <div style={{padding:'0px 20px 20px',flex:1}}>
                        <div style={{}} className='footer_h1'>Business Address</div>
                        <div style={{}} className='footer_h2'>Ad1, Makarfi Street</div>
                        <div style={{}} className='footer_h2'>Constitution, Kaduna</div>
                        <div style={{}} className='footer_h2'>Nigeria</div>
                    </div>


                    


                    
                </div>

                    <div className='last_footer_wrapper_pc'>
                        The Powerbox logo and technologies are trademark properties of Powerbox Energy systems LLC and its regional subsidiaries. 
                        <div style={{padding:'0px 20px 0px'}}>
                            &#169; 2024 Powerbox Energy systems LLC. All Rights Reserved.
                        </div> 
                    </div>

                
            </div>  
        )  
    }



export function AgentModal(){
    const [showModal, setShowModal] = useState(false);
  
    const toggleModal = () => {
      setShowModal(!showModal);
    };
  
    return (
      <div>
        <button 
            onClick={toggleModal} 
            style={{
                fontSize:'15px',fontFamily:"'Roboto', sans-serif",
                fontWeight:500,padding:'10px 20px 10px',borderRadius:5,border:'none',
                backgroundColor:'#318B27',color:'#FFFFFF'
                }}>Become a Distributor</button>


        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <span className="close" onClick={toggleModal}>
                &times;
              </span>
              <AgentForm/>
            </div>
          </div>
        )}
      </div>
    );
  };


  
  export function AgentForm(){
    const [formData, setFormData] = useState({
      name: '',
      location: '',
      phone: ''
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
    };


    const escapeHtml = (text) => {
        var map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
    
        return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }



    const openWhatsapp = (data) => {
        let safeText = escapeHtml(data);
        window.open("https://wa.me/+2349070811425?text="+safeText, "_blank");
        ReactGA.pageview("whatsapp clicked");
      }
  
    const handleSubmit = (e) => {
      e.preventDefault();
      // Handle form submission, you can send formData to an API, log it, etc.
      console.log(formData);
      // Clear form fields after submission
        if(!formData.name[0]){
            alert("Your fullname is required to proceed.");
            return;
        }

        if(!formData.location[0]){
            alert("The name of your location is required to proceed.");
            return;
        }

        if(!formData.phone[10]){
            alert("A valid phone number is required to proceed.");
            return;
        }
      
    //   setFormData({
    //     name: '',
    //     location: '',
    //     phone: ''
    //   });

    let textString = 'Hi, I am '+formData.name+' from '+formData.location+' You can reach me at '+formData.phone+'. I am interested in becoming a distributor for Powerbox.';

    console.log(textString);

      openWhatsapp(textString);

    };
  
    return (
        <div style={{padding:'0px 10px 0px'}}>

            <div style={{fontSize:'26px',fontFamily:"'Roboto', sans-serif",fontWeight:400,color:'#000000',textTransform:'capitalize',paddingBottom:40}}>
                Fill form to become a distributor.
            </div>

            <div style={{ }}>
                
                <form onSubmit={handleSubmit} className="form-container">
                    <div className="form-group">
                        <label className="form-label">FullName:</label>
                        <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Town/City or Location:</label>
                        <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        className="form-input"
                        />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Whatsapp Phone Number:</label>
                        <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="form-input"
                        />
                    </div>
                    <button type="submit" className="form-button">Submit</button>
                </form>

            </div>

        </div>
      
    );
  };







export default function Home(){

    useEffect(() => {
        ReactGA.pageview(window.location);
    },[]);

    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-device-width: 800px)'
      })


    return(
    <div>
        <Header/>
        <TopStage/>

        

        {(isDesktopOrLaptop)?
        <SecondStagePc/>:
        <SecondStageMobile/>}

        {(isDesktopOrLaptop)?
        <AnotherStagePC />:
        <AnotherStageMobile/>
        }

        {(isDesktopOrLaptop)?
        <NewStagePc/>:
        <NewStageMobile/>}
        
        {(isDesktopOrLaptop)?
        <AwardViewPc/>:
        <AwardViewMobile/>
        }

        {/* {(isDesktopOrLaptop)?
        <ThirdStagePc/>:
        <ThirdStageMobile/>} */}

        

        {(isDesktopOrLaptop)?
        <TestimonyFuncPc/>:
        <TestimonyFuncMobile/>}


        {(isDesktopOrLaptop)?
        <FourthStagePc />:
        <FourthStageMobile/>
        }

        {(isDesktopOrLaptop)?
        <FifthStagePc/>:
        <FifthStageMobile/>
        }

        

    </div>)
}